
import React, { useEffect } from 'react';
import { usePomodoro } from '../../context/PomodoroContext';

export default function PomodoroControls() {
  const { 
    state, 
    startTimer, 
    pauseTimer, 
    resetTimer, 
    skipToWork, 
    completePomodoro 
  } = usePomodoro();

  // 获取当前模式的悬停颜色
  const getHoverColorClass = () => {
    return state.mode === 'work' ? 'hover:bg-red-600' : 'hover:bg-teal-500';
  };

  // 工作模式下的按钮
  const renderWorkModeButtons = () => {
    const hoverClass = 'hover:bg-red-600';
    
    // 默认状态：未开始
    if (!state.isActive && !state.isPaused) {
      return (
        <div className="flex justify-center space-x-4">
          <button
            onClick={startTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            开始
          </button>
          <button
            disabled
            className="px-6 py-2 border border-white rounded-full text-white text-sm opacity-50 cursor-not-allowed"
          >
            停止
          </button>
        </div>
      );
    }
    
    // 已开始状态
    if (state.isActive && !state.isPaused) {
      return (
        <div className="flex justify-center space-x-4">
          <button
            onClick={pauseTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            暂停
          </button>
          <button
            onClick={resetTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            停止
          </button>
        </div>
      );
    }
    
    // 暂停状态
    if (state.isPaused) {
      return (
        <div className="flex justify-center space-x-4">
          <button
            onClick={startTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            继续
          </button>
          <button
            onClick={completePomodoro}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            已完成
          </button>
        </div>
      );
    }

    // 默认返回开始按钮（防止undefined）
    return (
      <div className="flex justify-center space-x-4">
        <button
          onClick={startTimer}
          className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
        >
          开始
        </button>
        <button
          disabled
          className="px-6 py-2 border border-white rounded-full text-white text-sm opacity-50 cursor-not-allowed"
        >
          停止
        </button>
      </div>
    );
  };

  // 休息模式下的按钮
  const renderBreakModeButtons = () => {
    const hoverClass = 'hover:bg-teal-500';
    
    // 已开始状态：正在休息
    if (state.isActive && !state.isPaused) {
      return (
        <div className="flex justify-center space-x-4">
          <button
            onClick={pauseTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            暂停
          </button>
          <button
            onClick={skipToWork}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            跳过
          </button>
        </div>
      );
    }
    
    // 暂停状态
    if (state.isPaused) {
      return (
        <div className="flex justify-center space-x-4">
          <button
            onClick={startTimer}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            继续
          </button>
          <button
            onClick={skipToWork}
            className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
          >
            跳过
          </button>
        </div>
      );
    }
    
    // 未开始状态（包括刷新后）
    return (
      <div className="flex justify-center space-x-4">
        <button
          onClick={startTimer}
          className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
        >
          开始休息
        </button>
        <button
          onClick={skipToWork}
          className={`px-6 py-2 border border-white rounded-full text-white ${hoverClass} focus:outline-none text-sm`}
        >
          跳过
        </button>
      </div>
    );
  };

  return (
    <div className="mt-8">
      {state.mode === 'work' ? renderWorkModeButtons() : renderBreakModeButtons()}
    </div>
  );
} 